import React from 'react';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-t1blue to-blue-700">
        <div className="absolute inset-0 bg-pattern opacity-10"></div>
        <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Automated Forex Trading
          </h1>
          <p className="mt-6 max-w-2xl text-xl text-blue-100">
            Connect your XM Global Metatrader 5 account to our proven automated trading strategies and let the expert advisors(EA) handle your trades. No coding or complex setup required.
          </p>
          <div className="mt-10 flex space-x-4">
            <Link
              to="/register"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-t1blue bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-t1blue"
            >
              Get Started
            </Link>
            <a
              href="#how-it-works"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-800 bg-opacity-60 hover:bg-opacity-70 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-t1blue"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="py-16 bg-gray-50 overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base font-semibold text-t1blue tracking-wide uppercase">
              Features
            </h2>
            <p className="mt-1 text-4xl font-extrabold text-gray-900 sm:text-5xl sm:tracking-tight">
              Why Choose Our Service
            </p>
            <p className="max-w-xl mt-5 mx-auto text-xl text-gray-500">
              Professional Forex automation without the complexity
            </p>
          </div>

          <div className="mt-16">
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              <div className="pt-6">
                <div className="flow-root bg-white rounded-lg px-6 pb-8 shadow-lg">
                  <div className="-mt-6">
                    <div>
                      <span className="inline-flex items-center justify-center p-3 bg-t1blue rounded-md shadow-lg">
                        <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                        </svg>
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Proven Strategies</h3>
                    <p className="mt-5 text-base text-gray-500">
                      Access professionally developed trading strategies with proven track records and consistent performance metrics.
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6">
                <div className="flow-root bg-white rounded-lg px-6 pb-8 shadow-lg">
                  <div className="-mt-6">
                    <div>
                      <span className="inline-flex items-center justify-center p-3 bg-t1blue rounded-md shadow-lg">
                        <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Secure Connection</h3>
                    <p className="mt-5 text-base text-gray-500">
                      Your trading account remains under your control.
                    </p>
                  </div>
                </div>
              </div>

              <div className="pt-6">
                <div className="flow-root bg-white rounded-lg px-6 pb-8 shadow-lg">
                  <div className="-mt-6">
                    <div>
                      <span className="inline-flex items-center justify-center p-3 bg-t1blue rounded-md shadow-lg">
                        <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                        </svg>
                      </span>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Easy Setup</h3>
                    <p className="mt-5 text-base text-gray-500">
                      Connect your broker account in minutes with our simple, guided process. No coding or complex configuration required.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* How it Works Section */}
      <div id="how-it-works" className="py-16 bg-white overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base font-semibold text-t1blue tracking-wide uppercase">
              Getting Started
            </h2>
            <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
              How It Works
            </p>
            <p className="mt-5 max-w-xl mx-auto text-xl text-gray-500">
              Follow these simple steps to start automated trading
            </p>
          </div>

          <div className="mt-16">
            <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
              <div className="relative">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-t1blue text-white">
                  <span className="text-lg font-bold">1</span>
                </div>
                <div className="ml-16">
                  <h3 className="text-lg font-medium text-gray-900">Purchase a Subscription</h3>
                  <p className="mt-2 text-base text-gray-500">
                    Visit <a href="https://www.t1fxteam.com" target="_blank" rel="noopener noreferrer" className="text-t1blue hover:text-t1blue-light">www.t1fxteam.com</a> to purchase a subscription. Each subscription allows you to add one trading account.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-t1blue text-white">
                  <span className="text-lg font-bold">2</span>
                </div>
                <div className="ml-16">
                  <h3 className="text-lg font-medium text-gray-900">Create an Account</h3>
                  <p className="mt-2 text-base text-gray-500">
                    Sign up for T1 FX Team with your email address and complete your profile information.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-t1blue text-white">
                  <span className="text-lg font-bold">3</span>
                </div>
                <div className="ml-16">
                  <h3 className="text-lg font-medium text-gray-900">Connect Your XM Global MT5 Account</h3>
                  <p className="mt-2 text-base text-gray-500">
                    Link your existing XM Global MetaTrader 5 account using your account number and server information.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-t1blue text-white">
                  <span className="text-lg font-bold">4</span>
                </div>
                <div className="ml-16">
                  <h3 className="text-lg font-medium text-gray-900">Select a Strategy</h3>
                  <p className="mt-2 text-base text-gray-500">
                    Browse our available trading strategies and choose the one that best matches your risk profile.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="absolute flex items-center justify-center h-12 w-12 rounded-md bg-t1blue text-white">
                  <span className="text-lg font-bold">5</span>
                </div>
                <div className="ml-16">
                  <h3 className="text-lg font-medium text-gray-900">Monitor Your Trades</h3>
                  <p className="mt-2 text-base text-gray-500">
                    Watch your trades being executed automatically and track your account's performance through our dashboard.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Subscription Information Section */}
      <div className="bg-gray-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base font-semibold text-t1blue tracking-wide uppercase">
              Subscriptions
            </h2>
            <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
              Premium Trading Strategy Access
            </p>
            <p className="mt-5 max-w-xl mx-auto text-xl text-gray-500">
              Visit our website for subscription details and pricing
            </p>
          </div>

          <div className="mt-16 bg-white rounded-lg shadow-xl overflow-hidden">
            <div className="py-12 px-6 text-center">
              <div className="flex flex-col items-center">
                <div className="h-16 w-16 bg-t1blue rounded-full flex items-center justify-center">
                  <svg className="h-8 w-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="mt-6 text-2xl font-extrabold text-gray-900">Subscription Benefits</h3>
                
                <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-8">
                  <div className="flex flex-col items-center">
                    <div className="rounded-full bg-t1blue bg-opacity-10 p-3">
                      <svg className="h-6 w-6 text-t1blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                    </div>
                    <h4 className="mt-4 text-lg font-medium text-gray-900">Professional Strategies</h4>
                    <p className="mt-2 text-sm text-gray-500 text-center">
                      Access to expert trading algorithms with proven track records
                    </p>
                  </div>
                  
                  <div className="flex flex-col items-center">
                    <div className="rounded-full bg-t1blue bg-opacity-10 p-3">
                      <svg className="h-6 w-6 text-t1blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
                      </svg>
                    </div>
                    <h4 className="mt-4 text-lg font-medium text-gray-900">Performance Monitoring</h4>
                    <p className="mt-2 text-sm text-gray-500 text-center">
                      Real-time tracking of your account performance and strategy execution
                    </p>
                  </div>
                  
                  <div className="flex flex-col items-center">
                    <div className="rounded-full bg-t1blue bg-opacity-10 p-3">
                      <svg className="h-6 w-6 text-t1blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </div>
                    <h4 className="mt-4 text-lg font-medium text-gray-900">Expert Support</h4>
                    <p className="mt-2 text-sm text-gray-500 text-center">
                      Access to our team of trading professionals to help with your account
                    </p>
                  </div>
                </div>
                
                <div className="mt-12">
                  <a 
                    href="https://www.t1fxteam.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-t1blue hover:bg-t1blue-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-t1blue"
                  >
                    View Subscription Plans
                    <svg className="ml-2 -mr-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </a>
                </div>
                
                <div className="mt-8 max-w-2xl text-center">
                  <p className="text-sm text-gray-500">
                    Each subscription allows you to add one trading account with access to multiple automated strategies. 
                    Visit our website for detailed subscription information, pricing, and available plans.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-base font-semibold text-t1blue tracking-wide uppercase">
              FAQ
            </h2>
            <p className="mt-2 text-3xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
              Frequently Asked Questions
            </p>
          </div>
          <div className="mt-12">
            <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12">
              <div>
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  How does your service work?
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Our service connects your XM Global MetaTrader 5 account to professional trading strategies. When the strategy places a trade, it's automatically linked to your account with the volume you specify.
                </dd>
              </div>
              <div>
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Is my money safe?
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Yes, your funds remain in your broker account. We never have access to withdraw your funds - we only connect to your account to open trades.
                </dd>
              </div>
              <div>
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  What brokers do you support?
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  We support XM Global MetaTrader 5 accounts.
                </dd>
              </div>
              <div>
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Can I change strategies?
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Yes, you can change your selected strategy at any time through your dashboard. You can also adjust your trade volume to match your risk tolerance.
                </dd>
              </div>
              <div>
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  Where can I purchase a subscription?
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  Subscriptions can be purchased on our main website at <a href="https://www.t1fxteam.com" target="_blank" rel="noopener noreferrer" className="text-t1blue hover:underline">www.t1fxteam.com</a>. Each subscription allows you to add one trading account with access to multiple automated strategies.
                </dd>
              </div>
              <div>
                <dt className="text-lg leading-6 font-medium text-gray-900">
                  How do I manage my subscription?
                </dt>
                <dd className="mt-2 text-base text-gray-500">
                  You can manage your subscription through our main website. When logged in to this app, you'll see your subscription status and can access all features based on your active subscription.
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-t1blue">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
          <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
            <span className="block">Ready to start trading?</span>
            <span className="block text-blue-200">Visit our website for subscriptions and create your account today.</span>
          </h2>
          <div className="mt-8 flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-3 lg:mt-0 lg:flex-shrink-0">
            <div className="inline-flex rounded-md shadow">
              <a
                href="https://www.t1fxteam.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-t1blue bg-white hover:bg-gray-50"
              >
                View Subscriptions
              </a>
            </div>
            <div className="inline-flex rounded-md shadow">
              <Link
                to="/register"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-800 hover:bg-blue-900"
              >
                Register
              </Link>
            </div>
            <div className="inline-flex rounded-md shadow">
              <Link
                to="/login"
                className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-700 hover:bg-blue-800"
              >
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;